package com.oratakashi.web.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.oratakashi.web.components.sections.Footer
import com.oratakashi.web.resources.NavigationStyle
import com.oratakashi.web.resources.R
import com.oratakashi.web.utils.Utility
import com.varabyte.kobweb.compose.css.AlignSelf
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun PageLayout(title: String, content: @Composable ColumnScope.(modifier: Modifier) -> Unit) {

    val breakpoint = rememberBreakpoint()

    LaunchedEffect(title) {
        document.title = "Abdul Hafiidh - $title"
    }

    Column(
        modifier = Modifier
            .background(color = R.colors.BACKGROUND.value)
            .display(DisplayStyle.Flex)
            .fillMaxSize(),
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1),
            contentAlignment = Alignment.Center
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth(
                        if (breakpoint <= Breakpoint.MD) 90.percent
                        else R.dimens.MAX_CARD_WIDTH.px
                    )
                    .gap(1.5.cssRem)
            ) {

                if(title != "Home") {
                    Button(
                        size = ButtonSize.LG,
                        variant = NavigationStyle,
                        onClick = {
                            window.document.location?.href = "/"
                        }
                    ) {
                        FaChevronLeft(
                            size = IconSize.LG,
                            modifier = Modifier
                                .align(Alignment.CenterVertically)
                                .color(R.colors.PRIMARY_500.value)
                        )
                        SpanText(
                            text = "Home",
                            modifier = Modifier
                                .fontFamily(R.font.PoppinsBold.name)
                                .margin(left = 8.px)
                        )
                    }
                }

                Column(
                    modifier = Modifier
                        .fillMaxWidth(
                            if (breakpoint <= Breakpoint.MD) 90.percent
                            else R.dimens.MAX_CARD_WIDTH.px
                        )
                        .background(R.colors.CARD_BACKGROUND_LIGHT.value)
                        .borderRadius(R.dimens.BORDER_RADIUS.px)
                        .boxShadow(
                            color = R.colors.SHADOW_COLORS.value.toRgb().copy(alpha = 20),
                            blurRadius = 60.px,
                            spreadRadius = 50.px
                        )
                        .padding(
                            topBottom = 35.px,
                            leftRight = 31.px
                        )
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .display(DisplayStyle.Flex)
                    ) {
                        Image(
                            src = R.drawable.PHOTO.link,
                            modifier = Modifier
                                .width(50.px)
                                .height(50.px)
                                .display(DisplayStyle.Block)
                        )

                        Column(
                            modifier = Modifier
                                .padding(leftRight = 16.px)
                        ) {
                            SpanText(
                                text = "Abdul Hafiidh S, A.M.Kom",
                                modifier = Modifier
                                    .fontFamily(R.font.PoppinsSemiBold.name)
                                    .fontSize(18.px)
                            )

                            SpanText(
                                text = "@oratakashi",
                                modifier = Modifier
                                    .fontFamily(R.font.PoppinsRegular.name)
                                    .fontSize(16.px)
                                    .color(R.colors.TERTIARY_400.value)
                            )
                        }

                        Spacer()

                        FaLinkedinIn(
                            size = IconSize.XL,
                            modifier = Modifier
                                .align(Alignment.CenterVertically)
                                .color(R.colors.PRIMARY_500.value)
                        )
                    }

                    content(
                        Modifier
                            .padding(
                                top = 1.3.cssRem,
                                bottom = 2.5.cssRem
                            )
                    )

                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .display(DisplayStyle.Flex),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FaHeart(
                            style = IconStyle.FILLED,
                            size = IconSize.LG,
                            modifier = Modifier
                                .align(Alignment.CenterVertically)
                                .color(R.colors.ERROR_500.value)
                        )

                        SpanText(
                            text = Utility.likeCount,
                            modifier = Modifier
                                .padding(left = 0.5.cssRem)
                                .fontFamily(R.font.PoppinsSemiBold.name)
                                .fontSize(14.px)
                                .color(R.colors.TERTIARY_500.value)
                        )

                        SpanText(
                            text = "•",
                            modifier = Modifier
                                .padding(left = 0.5.cssRem)
                                .fontFamily(R.font.PoppinsSemiBold.name)
                                .fontSize(14.px)
                                .color(R.colors.TERTIARY_500.value)
                                .align(Alignment.CenterVertically)
                        )

                        SpanText(
                            text = Utility.currentDate,
                            modifier = Modifier
                                .padding(left = 0.5.cssRem)
                                .fontFamily(R.font.PoppinsSemiBold.name)
                                .fontSize(14.px)
                                .color(R.colors.TERTIARY_500.value)
                        )
                    }
                }
            }
        }
        Footer(
            modifier = Modifier
                .alignSelf(AlignSelf.FlexEnd)
                .fillMaxWidth()
        )
    }
}